import { render, staticRenderFns } from "./MicroTopicList.vue?vue&type=template&id=1ed385df&scoped=true&"
import script from "./MicroTopicList.vue?vue&type=script&lang=js&"
export * from "./MicroTopicList.vue?vue&type=script&lang=js&"
import style0 from "./MicroTopicList.vue?vue&type=style&index=0&id=1ed385df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed385df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VDivider})
